export const TOURNAMENTS_LIST = "TOURNAMENTS_LIST";
export const TOURNAMENTS_DETAIL = "TOURNAMENTS_DETAIL";
export const OFFICIAL_TOURNAMENTS_APPLY = "OFFICIAL_TOURNAMENTS_APPLY";
